import { connectRouter } from 'connected-react-router';

import metadata from "./reducers/metadata";
import gameConfig from "../views/hitmaker/reducer/game_reducer";

const rootReducer = history => ({
  metadata,
  router: connectRouter(history),
  gameConfig
});

export default rootReducer;
